import axios from 'axios';
import GetCookie from '../utils/GetCookie';

const authNavigate = async (path, type = 'admin', navigate) => {
    const accessToken = GetCookie('access_token');
    const no_authcheck_paths = ['/admin-login' , '/login'];
    const endpoint = type === 'admin' 
        ? '/pceapi/auth/admin/authorizationcheck'
        : '/pceapi/auth/iamuser/authorizationcheck';
    console.log("no_auth_check has path:",!no_authcheck_paths.includes(path), "path : ", path, "type : ", type)
    if (!no_authcheck_paths.includes(path)){
        
    try {
        
        const response = await axios.post(endpoint, {}, {
            headers: { Authorization: accessToken }
        });
        
        if (response.data.status === 'Authorized') {
            navigate(path);
        } else {
            navigate(type === 'admin' ? '/admin-login' : '/login');
        }
    } catch (error) {
        console.error('Auth check failed:', error);
        navigate(type === 'admin' ? '/admin-login' : '/login');
    }}
    else {
        navigate(path)
    }
};

export default authNavigate;